import { GetUserAchLimitsModelDto as BoUserAchLimitsModelDto } from '@treasury/api/bo';
import { GetUserAchLimitsModelDto as ConsumerUserAchLimitsModelDto } from '@treasury/api/channel';
import { DomainEntity } from '../../../../shared';

const defaultCompanyUserAchLimits: BoUserAchLimitsModelDto = {
    userProductLimit: {
        initiationLimit: 0,
        approvalLimit: 0,
    },
    pendingUserProductLimit: {
        initiationLimit: 0,
        approvalLimit: 0,
    },
    userAchCompanies: [],
    productDailyLimit: 0,
};

export class CompanyUserAchLimits extends DomainEntity<
    BoUserAchLimitsModelDto | ConsumerUserAchLimitsModelDto
> {
    public userProductLimit = this.dto.userProductLimit;

    public get productInitiationLimit() {
        return this.dto.userProductLimit?.initiationLimit;
    }

    public get productApprovalLimit() {
        return this.dto.userProductLimit?.approvalLimit;
    }

    public get pendingProductInitiationLimit() {
        return this.dto.pendingUserProductLimit?.initiationLimit;
    }

    public get pendingProductApprovalLimit() {
        return this.dto.pendingUserProductLimit?.approvalLimit;
    }

    public get productDailyLimit() {
        return this.dto.productDailyLimit;
    }

    public get userAchCompanies() {
        return this.dto.userAchCompanies;
    }

    public createDefault(): this {
        return new CompanyUserAchLimits(defaultCompanyUserAchLimits) as this;
    }
}
